import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActionType } from '../../../actions/model';
import { AccountServiceMonthlyDecodingPayload } from 'app/content/wallet/components/ElectricityDecodingTemplate/model';


export interface AccountServiceMonthlyDecodingState {
    data: AccountServiceMonthlyDecodingPayload | null;
    isLoading: boolean;
    isLoaded: boolean;
    loadingError: string | null;
    isAccountServiceMonthlyDecodingModalOpen: boolean;
}

const initialState: AccountServiceMonthlyDecodingState = {
    data: null,
    isLoading: false,
    isLoaded: false,
    loadingError: null,
    isAccountServiceMonthlyDecodingModalOpen: false,
};

export const accountServiceMonthlyDecoding = createSlice({
    name: '@@vp/accounts/accountServiceMonthlyDecodingState',
    initialState,
    reducers: {
        setAccountServiceMonthlyDecodingLoading(state, action: PayloadAction<AccountServiceMonthlyDecodingState['isLoading']>): void {
            state.isLoading = action.payload;
        },
        resetAccountServiceMonthlyDecoding(state): void {
            state.data = initialState.data;
            state.isLoaded = initialState.isLoaded;
            state.isLoading = initialState.isLoading;
            state.loadingError = initialState.loadingError;
        },
        setAccountServiceMonthlyDecoding(state, action: PayloadAction<AccountServiceMonthlyDecodingPayload>): void {
            state.data = action.payload;
            state.isLoaded = true;
            state.isLoading = false;
        },
        setAccountServiceMonthlyDecodingLoadingError(state, action: PayloadAction<AccountServiceMonthlyDecodingState['loadingError']>): void {
            state.loadingError = action.payload;
        },
        setAccountServiceMonthlyDecodingIsModalOpen(state, action: PayloadAction<AccountServiceMonthlyDecodingState['isAccountServiceMonthlyDecodingModalOpen']>): void {
            state.isAccountServiceMonthlyDecodingModalOpen = action.payload;
        },
    },
    extraReducers: {
        [ActionType.LOGOUT]: (): AccountServiceMonthlyDecodingState => initialState,
    }
});

export const {
    setAccountServiceMonthlyDecodingLoading,
    resetAccountServiceMonthlyDecoding,
    setAccountServiceMonthlyDecoding,
    setAccountServiceMonthlyDecodingLoadingError,
    setAccountServiceMonthlyDecodingIsModalOpen,
} = accountServiceMonthlyDecoding.actions;
